import React from 'react';
import {Col, Row} from "reactstrap";
import TeamTable from "../components/TeamTable/TeamTable";
import {teamService} from "../services/team.service";
import {uniqueBy} from "../helpers";

class Teams extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            Data: []
        }
    }

    componentDidMount() {
        //hit the api to get information
        teamService.getAllTeams().then(resp => {
            this.setState({Data: resp})
        })
    }

    onColourSaved = (id, colour) => {
        teamService.updateColour(id, colour).then(resp => {
            this.setState({Data: resp});
        })
    }

    render() {
        //filter the array down into multiple tables
        const {Data} = this.state;
        const teams = uniqueBy(Data, "TeamName");
        teams.sort();
        return (
            <>
                <div className="content">
                    <Row>
                        { teams && teams.map(team => {
                            //try and filter the data to see what we can do
                            var inTeam = Data.filter(i => {
                                return i.TeamName == team;
                            })
                            return (
                                <Col xs={`12`}>
                                    <TeamTable onColourSave={this.onColourSaved} tableName={team} data={inTeam}/>
                                </Col>
                                )


                        })}
                    </Row>
                </div>
            </>
        )
    }
}

export default Teams;